import { PhoneNumberInput } from "@/components/ui/forms/phoneNumberInput"
import { StandardInput } from "@/components/ui/forms/standardInput"
import { type BoxFormPageProps } from "@modules/box/components/boxCreationForm/boxFormFirstPage"
import { BoxFormTemplatePage } from "@modules/box/components/boxCreationForm/boxFormTemplatePage"
import { word } from "@modules/core/utils/i18n"
import { useEffect } from "react"

export const BoxFormThirdPage = ({
  handleSubmit,
  onPrevious,
  formik,
  getFormErrorMessage,
  disabled,
}: BoxFormPageProps) => {
  useEffect(() => {
    if (formik.values.country && !formik.values.phoneNumberCountryCode)
      formik.setFieldValue("phoneNumberCountryCode", formik.values.country)
  }, [formik.values.country])

  return (
    <BoxFormTemplatePage
      onPrevious={onPrevious}
      handleSubmit={handleSubmit}
      disabled={disabled}
      pageNumber={3}
      header={{ title: word("box.creation.page.3.title") }}
    >
      <PhoneNumberInput
        isRequiredInput
        label={word("global.form.label.phoneNumber")}
        getFieldProps={formik.getFieldProps}
        name="phoneNumber"
        countryCodeName="phoneNumberCountryCode"
        setFieldValue={formik.setFieldValue}
        error={getFormErrorMessage("phoneNumber")}
      />

      <StandardInput
        name="email"
        isRequiredInput
        label={word("box.form.email.label")}
        setFieldValue={formik.setFieldValue}
        getFieldProps={formik.getFieldProps}
        error={getFormErrorMessage("email")}
        inputProps={{
          onBlur: (e) => {
            if (formik.handleBlur) formik.handleBlur(e, "email")
          },
        }}
      />
    </BoxFormTemplatePage>
  )
}
